import React from 'react';
import DashboardIframe from 'src/components/DashboardIframe';

const NotificationsView = () => {
  return (
    <DashboardIframe
      path="/notifications"
      title="Notificações"
    />
  );
};

export default NotificationsView;

